<template>
  <div>
    <v-form>
      <v-layout row="" wrap>
        <v-flex xs12 sm12 md12>
          <v-text-field hide-details="" :disabled="yolcuadi" v-model="val.YolcuAdi" tabindex="2" label="Yolcu Adı"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="3" label="Rez. Veren" v-model="val.RezervasyonVeren"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="4" v-model="val.RezervasyonAlan" label="Rez Alan"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="5" v-model="val.Email" label="Yolcu E-Posta"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="6" mask="NNNNNNNNNNNNNNN" v-model="val.BiletTel" label="Yolcu GSM"></v-text-field>
        </v-flex>

      </v-layout>
    </v-form>
  </div>
</template>

<script>
  export default {
    props: ["value", "yolcuadi"],
    beforeMount: beforeMount,
    components: {

    },

    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      }
    },
    methods: {},

    data() {
      return {}
    },

    watch: {

    },
    methods: {


    },


  }





  function beforeMount() {


  }
</script>